<template>
	<div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center reset-page" id="page-login">
		<div
			:class="{
				'lg:w-3/4 xl:w-3/5': !$store.getters.isClientUrl,
				'lg:w-2/4 xl:w-2/5 max-w-md': $store.getters.isClientUrl,
			 }"
			class="vx-col sm:w-1/2 md:w-1/2"
		>
			<vx-card>
				<div slot="no-body" class="full-page-bg-color">

					<div class="vx-row no-gutter justify-center">

						<img
							v-if="!$store.getters.isClientUrl"
							src="@/assets/images/pages/login.png"
							alt="login"
							class="mx-auto"
						>

						<div
							:class="{ 'lg:w-1/2': !$store.getters.isClientUrl }"
							class="vx-col sm:w-full md:w-full d-theme-dark-bg flex justify-center items-center"
						>
							<div class="px-8 pt-8 login-tabs-container">

								<div class="vx-card__title mb-4">
									<h4 class="mb-4"><b>{{ $t('passwordRecovery') }}</b></h4>
									<p>{{ $t('enterYourEmailAndWeWillSendYouNewPassword') }}</p>
								</div>

								<vs-input label="E-Mail" name="email" v-validate="'required|email|min:3'" class="w-full"
										  v-model="email"/>

								<span v-if="errors.first('email')" class="text-danger text-sm">
									{{ $t('fieldFilledIncorrect') }}
								</span>

								<div class="flex flex-wrap vx-row justify-between mb-3 my-5">
									<div class="vx-col mt-5">
										<vs-button :disabled="!validateForm" @click="resetPass">
											{{ $t('recoverPassword') }}
										</vs-button>
									</div>

									<div class="vx-col mt-5">
										<router-link to="/login">
											<vs-button type="border">{{ $t('toLoginPage') }}</vs-button>
										</router-link>
									</div>
								</div>

							</div>
						</div>
					</div>
				</div>
			</vx-card>
		</div>
	</div>
</template>


<script>
import notifier from "@/mixins/notifier";
import axios from '../../axios'

export default {
	mixins: [notifier],
	data() {
		return {
			email: ''
		}
	},
	computed: {
		validateForm() {
			return !this.errors.any() && this.email !== ''
		},
	},
	methods: {
		async resetPass() {
			try {
				let formData = new FormData();
				formData.append('email',this.email)
				let res = await axios.post('auth/reset-password',formData)

				this.email = '';
				this.notifySuccess(this.$t('newPasswordIsGeneratedAndSentToMail'));
			}catch (e) {
				this.notifyError(e.message);
			}
		}
	}
}
</script>

<style lang="scss">
.login-tabs-container {
	min-height: 280px;
	color: #626262;

	.con-tab {
		padding-bottom: 14px;
	}

	.con-slot-tabs {
		margin-top: 1rem;
	}
}

.reset-page {
	&__logo {
		max-width: 90%;
		max-height: 90%;
	}
}
</style>
